<template>
  <div class="schemeAdvantages-container">
    <div class="pc d-none d-lg-block">
      <p class="title">方案优势</p>
      <div class="container" data-aos="fade-left" :data-aos-duration="1 * 1000">
        <div class="top-box">
          <div class="audioVideo-engine">
            <img src="~/assets/img/solution/audioVideo-engine.png" alt="" />
            <p class="nav-text">音视频引擎</p>
            <p class="subtitle">
              自研的音视频技术平台，业界领先的实时音视频编<br />码技术，提供高清稳定的视频互动体验。
            </p>
          </div>
          <div class="flexible-deployment">
            <img src="~/assets/img/solution/flexible-deployment.png" alt="" />
            <p class="nav-text">灵活部署</p>
            <p class="subtitle">
              针对金融、政务、教育等行业提供私有化部署、公<br />有云服务以及混合云架构，支持单机部署、集群部<br />署，双机房多活等部署方式，保障信息安全，满足<br />监管部门要求。
            </p>
          </div>
        </div>
        <div class="middle-box">
          <div class="platform-compatible">
            <img src="~/assets/img/solution/platform-compatible.png" alt="" />
            <p class="nav-text">全平台兼容支持</p>
            <p class="subtitle">覆盖支持全H5/Web、Linux、PC端、<br />Android&iOS、小程序生态，各个平台互通。</p>
          </div>
          <div class="data-security">
            <img src="~/assets/img/solution/data-security.png" alt="" />
            <p class="nav-text">数据安全</p>
            <p class="subtitle">
              音视频流网络传输全程加密，支持国密。满足<br />
              金融监管要求，保证系统安全性、数据安全性、<br />
              传输安全性。
            </p>
          </div>
        </div>
        <div class="bottom-box">
          <img src="~/assets/img/solution/delivery-method.png" alt="" />
          <p class="nav-text">交付方式</p>
          <p class="subtitle">
            提供音视频底层SDK、智能视频aPaaS远程服务、<br />Zealcomm SaaS云服务三种灵活交付方式，提供不<br />同场景下的业务集成方式。
          </p>
        </div>
      </div>
    </div>

    <div class="d-lg-none mobile">
      <p class="title">方案优势</p>
      <div class="mobile-container" data-aos="fade-left" :data-aos-duration="1 * 1000">
        <ul class="scheme-advantages">
          <li>
            <img src="~/assets/img/solution/audioVideoEngine-mobile.png" alt="" />
            <div class="wrapper-box">
              <p class="nav-text">音视频引擎</p>
              <p class="subtitle">自研的音视频技术平台，业界领先的实时音视频编码技术，提供高清稳定的视频互动体验。</p>
            </div>
          </li>
          <li>
            <img src="~/assets/img/solution/flexibleDeployment-mobile.png" alt="" />
            <div class="wrapper-box">
              <p class="nav-text">灵活部署</p>
              <p class="subtitle">
                针对金融、政务、教育等行业提供私有化部署、公有云服务以及混合云架构，支持单机部署、集群部署，双机房多活等部署方式，保障信息安全，满足监管部门要求。
              </p>
            </div>
          </li>
          <li>
            <img src="~/assets/img/solution/dataSecurity-mobile.png" alt="" />

            <div class="wrapper-box">
              <p class="nav-text">数据安全</p>
              <p class="subtitle">
                音视频流网络传输全程加密，支持国密。满足金融监管要求，保证系统安全性、数据安全性、传输安全性。
              </p>
            </div>
          </li>
          <li>
            <img src="~/assets/img/solution/deliveryMethod-mobile.png" alt="" />
            <div class="wrapper-box">
              <p class="nav-text">交付方式</p>
              <p class="subtitle">
                提供音视频底层SDK、智能视频aPaaS远程服务、Zealcomm
                SaaS云服务三种灵活交付方式，提供不同场景下的业务集成方式。
              </p>
            </div>
          </li>
          <li>
            <img src="~/assets/img/solution/platformCompatible-mobile.png" alt="" />
            <div class="wrapper-box">
              <p class="nav-text">全平台兼容支持</p>
              <p class="subtitle">覆盖支持全H5/Web、Linux、PC端、Android&iOS、小程序生态，各个平台互通。</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  export default {};
</script>

<style lang="scss" scoped>
  .pc {
    @import "./title.scss";
    overflow: hidden;
    background-image: url("https://zealcomm-site-assets.zealcomm.cn/new-product/scheme-advantages.png");
    background-repeat: no-repeat;
    background-size: 378px 378px;
    background-position: center;
    text-align: center;
    padding-bottom: 111px;
    .title {
      @extend %title;
      margin-top: 90px;
    }

    .container {
      .top-box {
        display: flex;
        justify-content: space-around;
        margin: 48px -97px 0;

        .audioVideo-engine {
        }
        .flexible-deployment {
        }
      }
      .middle-box {
        display: flex;
        justify-content: space-around;
        margin: 73px -203px 0;
        .platform-compatible {
        }
        .data-security {
        }
      }
      .bottom-box {
        margin-top: 66px;
      }

      img {
        width: 54px;
        height: 54px;
      }
      .nav-text {
        font-size: 22px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #0ac6ad;
        margin-top: 16px;
      }
      .subtitle {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #444444;
        margin-top: 16px;
      }
    }
  }
  .mobile {
    @import "./mobileTitle.scss";
    .title {
      @extend %mobileTitle;
      padding-top: 40px;
    }
    .mobile-container {
      padding-bottom: 60px;
      .scheme-advantages {
        margin: 0 20px 0 20px;
        li {
          display: flex;
          margin-top: 36px;
        }
      }
      .wrapper-box {
        margin-left: 14px;
      }
      img {
        width: 38px;
        height: 38px;
      }
      .nav-text {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #0ac6ad;
      }
      .subtitle {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #444444;
        // padding: 10px 20px 36px 72px;
        padding-top: 10px;
      }
    }
  }
</style>
